export default __webpack_public_path__ + "static/media/Bezel_Blue_Red.0039ecd0.png";